<template>
    <div>
    <transition name="slide-fade">
        <v-card
    v-if="edicion == false"   
    class="mx-auto"
    max-width="400"
  >
    <v-img
      v-if="type != 'asignacion'"
      class="white--text align-end"
      height="200px"
      :src="data.valor.images[0]?data.valor.images[0].image:require('@/assets/images/noimage.png')"
    >
    </v-img>
     <v-card-text class="text--primary">
      <div> {{data.valor.name}} </div>
      <div v-if="data.type == 'vehiculos'"> {{data.valor.enrollment}} </div>
      <div v-if="data.type == 'conductores'"> {{data.valor.dni}} </div>
      <div v-if="data.type == 'asignacion'"> {{data.valor.conductor}} - {{data.valor.asignacion}} </div>
    </v-card-text>

    <v-card-actions>
      

        <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click.prevent="exitsingle" class="mx-2" fab dark small color="seccundary" v-on="on">
        <v-icon dark>mdi-keyboard-backspace</v-icon>
      </v-btn>
      </template>
      <span>Atras</span>
    </v-tooltip>


    <v-tooltip bottom v-if="type == 'vehiculos' || type == 'conductores'">
      <template v-slot:activator="{ on }">
       <v-btn @click.prevent="edicion = !edicion" class="mx-2" fab dark small color="primary" v-on="on">
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
      </template>
      <span>Edicion</span>
    </v-tooltip>

    <v-tooltip bottom v-if="type == 'vehiculos' || type == 'conductores'">
      <template v-slot:activator="{ on }">
       <v-btn @click="dialog = !dialog" class="mx-2" fab dark small color="danger" v-on="on">
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
      </template>
      <span>Eliminar</span>
    </v-tooltip>

    <v-tooltip bottom v-if="type == 'asignacion'">
      <template v-slot:activator="{ on }">
       <v-btn @click="dialog = !dialog" class="mx-2" fab dark small color="danger" v-on="on">
        <v-icon dark>mdi-repeat-off</v-icon>
      </v-btn>
      </template>
      <span>Remover Asignacion</span>
    </v-tooltip>


    

    

    

      
    </v-card-actions>
  </v-card>
    </transition>
    


<transition name="slide-fade">
    <v-card
    v-if="edicion == true"
    class="mx-auto"
    max-width="344"
    outlined
    >
    <v-list-item three-line>
      <v-list-item-content>
          
          <v-form>
            
          <v-file-input v-if="type != 'asignacion'" accept="image/png, image/jpeg, image/bmp" v-model="images" label="Agregar imagen"></v-file-input>
         
          <v-text-field
            v-if="type == 'vehiculos' || type == 'conductores'"
            v-model="data.valor.name"
            label="Marca y modelo"
            required
            >
            </v-text-field>

            <v-text-field
            v-if="type == 'vehiculos'"
            v-model="data.valor.enrollment"
            label="Placa"
            required
            >
            </v-text-field>

            <v-text-field
            v-if="type == 'conductores'"
            v-model="data.valor.dni"
            label="Cedula"
            required
            >
            </v-text-field>
          </v-form>

          

            



      </v-list-item-content>

   
    </v-list-item>

    <v-card-actions>
      
      <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click.prevent="edicion = !edicion" class="mx-2" fab dark small color="seccundary" v-on="on">
        <v-icon dark>mdi-keyboard-backspace</v-icon>
      </v-btn>
      </template>
      <span>Atras</span>
    </v-tooltip>
      
      <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click.prevent="editar()" class="mx-2" fab dark small color="primary" v-on="on">
        <v-icon dark>mdi-content-save</v-icon>
      </v-btn>
      </template>
      <span>Guardar</span>
    </v-tooltip>
    </v-card-actions>
  </v-card>
</transition>



    <v-dialog
      v-model="dialog"
      width="500"
    >
    

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Eliminar ( {{data.valor.name}} )
        </v-card-title>

        <v-card-text>
          Estas seguro que quieres Eliminar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          
          
          <v-btn
            color="primary"
            text
            @click="eliminar"
          >
            Si
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
  
            <v-btn
            color="seccundary"
            text
            @click="dialog = !dialog"
          >
            no
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>


    </div>
</template>
<script>

import {EditarConductor, DeleteConductor} from '../../../../../services/team/driving'
import {EditarVehicle, DeleteVehicle} from '../../../../../services/team/vehicle'
import {QuitarAsignacion} from '../../../../../services/team/asignacion'
 
export default {
    
    props:{

        data:'',
        type:'',

    },

    

    data(){
        return{
            overlay: false,
            edicion:false,
            images:[],
            dialog: false,

        }
    },
 
    methods: {
        exitsingle(){
            this.$store.dispatch('selectTableAction', []);
        },

        editar:function(){

            if (this.type == 'conductores') {
                var data = new FormData;
                data.append('name', this.data.valor.name);
                data.append('dni', this.data.valor.dni);
                
                if (this.images) {
                    data.append('images', this.images);    
                }
                EditarConductor(data, this.data.valor.id).then(response=>{
                    this.$store.dispatch('GetDrivings');
                    this.$toastr.success('se ha modificado el conductor con exito', 'Exito');
                    this.exitsingle();
                }).catch(errors=>{
                    console.log(errors);
                    this.$toastr.error(errors, 'Error');
                });
            }
            
            
            if (this.type == 'vehiculos') {
                
                var data = new FormData;
                data.append('name', this.data.valor.name);
                data.append('enrollment', this.data.valor.enrollment);
                
                if (this.images) {
                    data.append('images', this.images);    
                }
                EditarVehicle(data, this.data.valor.id).then(response=>{
                    this.$store.dispatch('GetVehicles');
                    this.$toastr.success('se ha modificado el vehiculo con exito', 'Exito');
                    this.exitsingle();
                }).catch(errors=>{
                    console.log(errors);
                    this.$toastr.error(errors, 'Error');
                });

            }
            if (this.type == 'asignacion') {
                console.log('estamos editando desde asignacion')
            }

        },


        eliminar:function(){

            if (this.type == 'conductores') {
                DeleteConductor(this.data.valor.id).then(response=>{
                    this.$store.dispatch('GetDrivings');
                    this.$toastr.success('se ha eliminado al conductor con exito', 'Exito');
                    this.exitsingle();
                }).catch(errors=>{
                    console.log(errors)
                });
            }

            if (this.type == 'vehiculos') {

                DeleteVehicle(this.data.valor.id).then(response=>{
                    this.$store.dispatch('GetVehicles');
                    this.$toastr.success('Se ha eliminado el vehiculo con exito', 'Exito');
                    this.exitsingle();
                }).catch(errors=>{
                    console.log(errors)
                    this.$toastr.error(errors, 'Error');
                })
              
            }

            if (this.type == 'asignacion') {

                var data = new FormData;
                data.append('vehicle_id', this.data.valor.id_vehicle);
                data.append('conductor_id', this.data.valor.id_conductor);

                QuitarAsignacion(data).then(response=>{
                    this.$store.dispatch('GetAsign');
                    this.$toastr.success('se ha removio el item', 'Exito');
                    this.exitsingle();
                }).catch(errors=>{
                    console.log(errors)
                    this.$toastr.error(errors, 'Error');
                })
            }

        },

        


    },


}
</script>